module.exports = __webpack_public_path__ + "files/hard.19d815bb6841a01bfefcef5578d4de9c.png";